const ExpenseBudget = {

    // PAGE HEADER
    "expenseBudget": "Expense Budget",

    // FIELDS
    "premise": "Premise",
    "financial_year": "Financial Year",
    "expense_head": "Expense Head",
    "budget_amount": "Budget Amount",

    // MESSAGES
    "select_filters": "Select Premise and Financial Year to load expense heads.",
    "no_expense_heads": "No expense heads found for the selected Premise.",
    "budget_section": "Budget Allocation",

    // ERROR
    "error_premise": "Select Premise",
    "error_financial_year": "Select Financial Year",
    "error_budget_amount": "Enter a valid amount",
    "error_negative": "Amount cannot be negative",

}

export default ExpenseBudget;